import React from "react";
import type { FC } from "react";

import { useSubscriptionsState } from "./SubscriptionsProvider.state";
import { SubscriptionsProviderContext } from "./SubscriptionsProvider.context";

const SubscriptionsProviderContextProvider = SubscriptionsProviderContext.Provider;

const SubscriptionsProvider: FC = (props) => {
  const { children } = props;

  const state = useSubscriptionsState();

  return <SubscriptionsProviderContextProvider value={state}>{children}</SubscriptionsProviderContextProvider>;
};

export { SubscriptionsProvider };
